import React from 'react';
import { motion } from 'framer-motion';
import { Plane, Compass, Home as HomeIcon, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const fadeIn = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.6
  }
};
export function Buyers() {
  return <div className="w-full bg-sand min-h-screen pt-24" data-id="element-265">
      {/* Hero */}
      <section className="py-20 px-4 text-center max-w-4xl mx-auto" data-id="element-266">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl md:text-6xl font-serif text-navy mb-6" data-id="element-267">
          Find Your Sanctuary
        </motion.h1>
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="text-lg md:text-xl font-light text-navy/70 leading-relaxed" data-id="element-268">
          Whether you're seeking a beachfront villa, a golf course estate, or a
          modern condo, we guide you through every step of acquiring your piece
          of paradise in Los Cabos.
        </motion.p>
      </section>

      {/* Why Cabo */}
      <section className="py-20 bg-white" data-id="element-269">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-270">
          <motion.div {...fadeIn} className="text-center mb-16" data-id="element-271">
            <h2 className="text-3xl md:text-4xl font-serif text-navy mb-4" data-id="element-272">
              Why Los Cabos?
            </h2>
            <p className="text-navy/60 font-light max-w-2xl mx-auto" data-id="element-273">
              Where the desert meets the sea. A unique blend of natural beauty,
              luxury amenities, and incredible accessibility.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-274">
            <motion.div {...fadeIn} transition={{
            delay: 0.1
          }} className="text-center" data-id="element-275">
              <div className="w-16 h-16 mx-auto bg-sand rounded-full flex items-center justify-center mb-6" data-id="element-276">
                <Plane className="text-gold" size={28} data-id="element-277" />
              </div>
              <h3 className="text-xl font-serif text-navy mb-3" data-id="element-278">
                Incredible Access
              </h3>
              <p className="text-navy/70 font-light text-sm leading-relaxed" data-id="element-279">
                Direct flights from major hubs. Just 2h 15m from Salt Lake City,
                2h 30m from Dallas, and 2h from LA. Leave in the morning, be on
                the beach by noon.
              </p>
            </motion.div>
            <motion.div {...fadeIn} transition={{
            delay: 0.2
          }} className="text-center" data-id="element-280">
              <div className="w-16 h-16 mx-auto bg-sand rounded-full flex items-center justify-center mb-6" data-id="element-281">
                <Compass className="text-gold" size={28} data-id="element-282" />
              </div>
              <h3 className="text-xl font-serif text-navy mb-3" data-id="element-283">Dual Nature</h3>
              <p className="text-navy/70 font-light text-sm leading-relaxed" data-id="element-284">
                Ski the mountains in the US on Friday, surf the Pacific in Cabo
                on Saturday. Enjoy world-class golf, deep-sea fishing, and
                desert off-roading all in one place.
              </p>
            </motion.div>
            <motion.div {...fadeIn} transition={{
            delay: 0.3
          }} className="text-center" data-id="element-285">
              <div className="w-16 h-16 mx-auto bg-sand rounded-full flex items-center justify-center mb-6" data-id="element-286">
                <HomeIcon className="text-gold" size={28} data-id="element-287" />
              </div>
              <h3 className="text-xl font-serif text-navy mb-3" data-id="element-288">
                Strong Investment
              </h3>
              <p className="text-navy/70 font-light text-sm leading-relaxed" data-id="element-289">
                A robust luxury market with strong appreciation and excellent
                rental yield potential for part-time residents.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Featured Communities */}
      <section className="py-24 bg-navy text-sand" data-id="element-290">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-291">
          <motion.div {...fadeIn} className="mb-12 flex justify-between items-end" data-id="element-292">
            <div data-id="element-293">
              <h2 className="text-3xl md:text-4xl font-serif text-white mb-4" data-id="element-294">
                Featured Communities
              </h2>
              <p className="text-sand/70 font-light max-w-xl" data-id="element-295">
                Explore the most prestigious addresses in Baja California Sur.
              </p>
            </div>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-296">
            {[{
            name: 'Querencia',
            desc: 'Private golf club and community offering a serene, family-focused lifestyle.',
            img: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&q=80'
          }, {
            name: 'Chileno Bay',
            desc: "Contemporary luxury on one of Cabo's only swimmable beaches.",
            img: 'https://images.unsplash.com/photo-1510097467424-192d713fd8b2?auto=format&fit=crop&q=80'
          }, {
            name: 'Quivira',
            desc: 'Spectacular cliffside golf and resort living on the Pacific coast.',
            img: 'https://images.unsplash.com/photo-1512100356356-de1b84283e18?auto=format&fit=crop&q=80'
          }, {
            name: 'Pedregal',
            desc: 'The Beverly Hills of Cabo. Historic, prestigious, and walking distance to downtown.',
            img: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&q=80'
          }].map((community, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="group relative h-80 overflow-hidden" data-id="element-297">
                <img src={community.img} alt={community.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-298" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/90 via-navy/40 to-transparent" data-id="element-299" />
                <div className="absolute bottom-0 left-0 p-8" data-id="element-300">
                  <h3 className="text-2xl font-serif text-white mb-2" data-id="element-301">
                    {community.name}
                  </h3>
                  <p className="text-sand/80 font-light text-sm max-w-md" data-id="element-302">
                    {community.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>

          <motion.div {...fadeIn} className="mt-12 text-center" data-id="element-303">
            <Link to="/communities" className="inline-flex items-center border border-white/30 text-white px-8 py-4 uppercase tracking-wider text-sm font-medium hover:bg-white hover:text-navy transition-colors group" data-id="element-304">
              View All Communities
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} data-id="element-305" />
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Process & CTA */}
      <section className="py-24 bg-sand" data-id="element-306">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-307">
          <motion.div {...fadeIn} data-id="element-308">
            <h2 className="text-3xl font-serif text-navy mb-6" data-id="element-309">
              Buying in Mexico, Simplified.
            </h2>
            <p className="text-navy/70 font-light text-lg mb-10 leading-relaxed" data-id="element-310">
              Purchasing property in Mexico as a foreigner involves a
              'Fideicomiso' (bank trust) or a Mexican Corporation. While it
              sounds complex, our team and our partners in{' '}
              <strong data-id="element-311">The Collective</strong> make the process seamless, secure,
              and transparent.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-312">
              <Link to="/contact" className="bg-navy text-white px-8 py-4 uppercase tracking-wider text-sm font-medium hover:bg-navy-light transition-colors" data-id="element-313">
                Schedule a Consultation
              </Link>
              <Link to="/collective" className="border border-navy text-navy px-8 py-4 uppercase tracking-wider text-sm font-medium hover:bg-navy hover:text-white transition-colors" data-id="element-314">
                Meet Our Legal Partners
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
}